import { render, staticRenderFns } from "./CalendarApp.vue?vue&type=template&id=920f7e9c"
import script from "./CalendarApp.vue?vue&type=script&lang=js"
export * from "./CalendarApp.vue?vue&type=script&lang=js"
import style0 from "./CalendarApp.vue?vue&type=style&index=0&id=920f7e9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports